export const ROW_DETAILS_TABLE_TOGGLE = 'row_details_table_toggle';
